<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button :to="`/upsells/new`" color="primary" type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(publish_status)="data">
          <span v-if="data.item.publish_status == 1" class="text-success"
            >Active</span
          >
          <span v-if="data.item.publish_status == 0" class="text-danger"
            >Inactive</span
          >
        </template>

        <template v-slot:cell(titledesc)="data">
          <div v-html="data.item.title"></div>
          <div
            style="font-size: 11px; color: rgba(0, 0, 0, 0.45)"
            v-html="data.item.description"
          ></div>
        </template>

        <template v-slot:cell(trigger)="data">
          <div>
            <div style="font-size: 11px; color: rgba(0, 0, 0, 0.45)">
              {{ triggerByText(data) }}
            </div>
            <div>{{ triggerValueText(data) }}</div>
          </div>
        </template>

        <template v-slot:cell(upsellaction)="data">
          <div v-if="data.item.actions">
            <div
              style="font-size: 11px; color: rgba(0, 0, 0, 0.45)"
            >
              {{ actionTypeText(data.item.actions.type) }}
            </div>
            <div v-if="data.item.actions.type == 'show_content_in_page'">
              <div>
                {{ actionFormatText(data.item.actions.content.format) }}
              </div>
            </div>
          </div>
        </template>

        <template v-slot:cell(upsellproducts)="data">
          <div v-if="data.item.actions">
            <div v-if="data.item.actions.type == 'show_content_in_page'">
              <vs-chip
                class=""
                v-for="(product, productindex) in getProductListFordisplay(
                  data.item.actions.content.product_ids
                )"
                :key="productindex"
              >
                {{ product }}
              </vs-chip>
              <vx-tooltip
                v-if="data.item.actions.content.show_fallback_items"
                :text="`Shows items dynamically`"
                position="top"
              >
                <vs-chip>
                  <i class="fa fa-magic"></i>
                </vs-chip>
              </vx-tooltip>
            </div>
          </div>
        </template>

        <template v-slot:cell(date)="data">
          <strong>{{ data.item.date }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button
            :to="`/upsells/${data.item.trigger_id}/view`"
            color="primary"
            type="flat"
            >Edit</vs-button
          >
          <vs-button
            @click="showDeleteDialog(data.item.trigger_id)"
            color="primary"
            type="flat"
            >Delete</vs-button
          >
        </template>
      </b-table>
    </vx-card>

    <vs-popup title="Remove Upsell?" :active.sync="confirmDeleteDialog">
      <div style="min-height: 100px" class="m-5">
        Are you sure you want to remove this Upsell?
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="removeUpsell(deleteIndex)"
          >Delete</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="confirmDeleteDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Remove Upsell" :active.sync="sucessDeleteDialog">
      <div style="min-height: 100px" class="m-5">Remove Upsell Success</div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="sucessDeleteDialog = false"
          >OK
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Service from "@/services";

export default {
  data: () => ({
    columns: [
      // { label: "ID", key: "trigger_id", sortable: false },
      // {
      //   label: "Title",
      //   key: "title",
      //   sortable: false,
      //   tdClass: "width-450",
      // },
      // { label: "Description", key: "description", sortable: false },
      // { label: "", key: "action", sortable: false },
      { label: "ID", key: "trigger_id", sortable: false },
      { label: "Status", key: "publish_status", sortable: false },
      {
        label: "Campaign",
        key: "titledesc",
        sortable: false,
        tdClass: "width-450",
      },
      // {
      //   label: "Title",
      //   key: "promotitle",
      //   sortable: false,
      //   tdClass: "width-450"
      // },
      // {
      //   label: "Description",
      //   key: "promodesc",
      //   sortable: false,
      //   tdClass: "width-450"
      // },
      { label: "Trigger", key: "trigger", sortable: false },
      { label: "Actions", key: "upsellaction", sortable: false },
      { label: "Products", key: "upsellproducts", sortable: false },
      // { label: "Level", key: "disclevel", sortable: false },
      // { label: "Discount from", key: "discfrom_display", sortable: false },
      // { label: "Start", key: "date_start", sortable: false },
      // { label: "End", key: "date_end", sortable: false },
      // { label: "Applies to", key: "applyto", sortable: false },
      // {
      //   label: "Usage",
      //   key: "usage",
      //   sortable: false,
      //   tdClass: "width-450",
      // },
      // // { label: "Apply to", key: "applyto", sortable: false },
      // { label: "Note", key: "promonote", sortable: false },
      { label: "", key: "action", sortable: false },
    ],
    triggerOptions: [
      {
        label: "Visit page",
        value: "visit-page",
      },
      {
        label: "Ticket added",
        value: "visit-page",
      },
      {
        label: "Click Submit",
        value: "click-submit",
      },
      {
        label: "Exit",
        value: "exit",
      },
      {
        label: "Time on page",
        value: "time-on-page",
      },
    ],
    triggerValueOptions: [
      {
        label: "Register",
        value: "register",
      },
      {
        label: "Thank you",
        value: "thankyou",
      },
      {
        label: "Attendee Info",
        value: "attendee_info",
      },
    ],
    actionOptions: [
      {
        text: "Show Content In Page",
        value: "show_content_in_page",
      },
    ],
    offerTypeOptions: [
      {
        text: "One time offer",
        value: "one-time-offer",
      },
      {
        text: "Add-Ons List",
        value: "add-ons-list",
      },
    ],
    data: [],
    products: [],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    deleteIndex: -1,
    confirmDeleteDialog: false,
    sucessDeleteDialog: false,
  }),

  mounted() {
    window.addEventListener("keydown", (e) => {
      if (this.remarkDialog == false) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },

  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    showDeleteDialog(id) {
      this.deleteIndex = id;
      this.confirmDeleteDialog = true;
    },
    removeUpsell(id) {
      // remove the question at the specified index

      Service.Upsell.delete(id).then(() => {
        this.confirmDeleteDialog = false;
        setTimeout(() => {
          this.sucessDeleteDialog = true;
        }, 800);
      });
    },
    triggerByText(data) {
      const trigger_by = this.triggerOptions.find(
        (t) => t.value == data.item.trigger_by
      );
      return `${trigger_by ? trigger_by.label : ""}`;
    },
    triggerValueText(data) {
      const trigger_value = this.triggerValueOptions.find((t) => {
        return t.value == data.item.trigger_value;
      });

      return `${trigger_value ? trigger_value.label : ""}`;
    },
    actionTypeText(val) {
      const value = this.actionOptions.find((t) => {
        console.log(t.value, val);
        return t.value == val;
      });

      return `${value ? value.text : ""}`;
    },
    actionFormatText(val) {
      const value = this.offerTypeOptions.find((t) => {
        return t.value == val;
      });

      return `${value ? value.text : ""}`;
    },
    getProductListFordisplay(product_ids, is_show_fallback_item) {
      let products = product_ids
        .map((item) => this.products.find((p) => p.value == item))
        .filter((item) => !!item)
        .map((item) => item.label);
      if (products.length > 2) {
        products = [products[0], products[1], `+${products.length - 2}`];
      }

      if (is_show_fallback_item) {
        products = [...products, `<i class="fa fa-magic"></i>`];
      }
      return products;
    },
    async fetchProducts() {
      await Service.Event.getProducts(this.e || this.$route.query.e).then(
        (products) => {
          this.products = products.data.items || [];

          // this.remain_quantity = parseInt(products.data.remain_free);
          this.products = this.products.map((item) => {
            return {
              label: item.pro_name,
              value: item.product_id,
            };
          });
        }
      );
    },
    async dataProvider(ctx, callback) {
      //console.log("loading...");
      setTimeout(async () => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
          s: this.$route.query.s,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        console.log(params);

        Service.Upsell.gets(params)
          .then(async (res) => {
            await this.fetchProducts();
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;
            // this.log = res.log;
            // this.lagacy_query = res.lagacy_query;

            console.log(this.data);

            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1800);
    },
    open(item) {
      //console.log(item);
      this.$router.push("/forms/" + item.form_id);
    },
  },
};
</script>

<style>
.width-250 {
  width: 250px;
}
.width-300 {
  width: 300px;
}
.width-450 {
  width: 450px;
}
</style>
